import { Typography } from '@data-products-and-ai/react-components';
import classNames from 'classnames';
import { FC } from 'react';

import '@/components/DataItem/DataItem.scss';

interface DataItemProps {
  single?: boolean;
  hideLabel?: boolean;
  inline?: boolean;
  key: string;
  label?: string;
  value: React.ReactNode;
  mode?: 'light' | 'dark';
}

export const DataItem: FC<DataItemProps> = ({
  single,
  hideLabel,
  inline,
  key,
  label,
  value,
  mode = 'light',
}) => (
  <div
    className={classNames('data-item', {
      'data-item--single': single,
      'data-item--inline': inline,
    })}
    key={key}
  >
    {!hideLabel && (
      <Typography
        color={
          mode === 'dark' ? 'var(--color-background)' : 'var(--color-default)'
        }
        tag="textsmall"
      >
        {label}
      </Typography>
    )}
    <Typography
      color={mode === 'dark' ? 'var(--color-white)' : 'var(--color-neutral)'}
    >
      {value}
    </Typography>
  </div>
);
